import { useLazyQuery } from "@apollo/client";
import { IS_INDIVIDUAL_EDITABLE,IS_INDIVIDUAL_IN_SCOPE, IS_INDIVIDUAL_READONLY } from "../graphql/individual-gql";
import { useEffect, useState } from "react";

const useIndividualScope =  (individualId: number) => {
  const [editable, setEditable] = useState<boolean>(false);
  const [inScope,setInScope] = useState<boolean>(false);
  const [readonly,setReadonly] = useState<boolean>(false);
  const [loadEditable] = useLazyQuery(IS_INDIVIDUAL_EDITABLE, { variables: { individualId } });
  const [loadScope] = useLazyQuery(IS_INDIVIDUAL_IN_SCOPE, { variables: { individualId } });
  const [loadReadonly] = useLazyQuery(IS_INDIVIDUAL_READONLY, { variables: { individualId } });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await loadEditable();
        setEditable(response.data?.isIndividualEditable || false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [loadEditable]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await loadScope();
        setInScope(response.data?.isIndividualInScope || false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [loadScope]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await loadReadonly();
        setReadonly(response.data?.isIndividualReadonly || false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [loadScope]);

  return { editable, inScope,readonly};
}

export default useIndividualScope;
